import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const CART_KEY = "velluto_cart_id";

export const api = axios.create({ baseURL: API });

export const getMenu = async () => {
  const { data } = await api.get("/menu");
  return data;
};

export const ensureCart = async () => {
  let cartId = localStorage.getItem(CART_KEY);
  if (cartId) {
    try {
      const { data } = await api.get(`/cart/${cartId}`);
      return data;
    } catch (e) {
      localStorage.removeItem(CART_KEY);
    }
  }
  const { data } = await api.post("/cart");
  localStorage.setItem(CART_KEY, data.id);
  return { ...data, total: 0 };
};

export const addToCart = async (cartId, productId, quantity = 1) => {
  const { data } = await api.post(`/cart/${cartId}/items`, {
    product_id: productId,
    quantity,
  });
  return data;
};

export const updateItem = async (cartId, itemId, quantity) => {
  const { data } = await api.patch(`/cart/${cartId}/items/${itemId}`, {
    quantity,
  });
  return data;
};

export const removeItem = async (cartId, itemId) => {
  const { data } = await api.delete(`/cart/${cartId}/items/${itemId}`);
  return data;
};
